import { createAction } from '@reduxjs/toolkit';

const actions = {
    sidebarTabSelectionChanged: createAction<string>('monitor/sidebar/TAB_SELECTION_CHANGED'),
    assetSelectedFromClusterSidebar: createAction<string>('monitor/sidebar/ASSET_SELECTED_FROM_CLUSTER_SIDEBAR'),
};

export const sidebarActions = actions;
